<template>
  <div >
    <div class="w-full flex flex-wrap justify-between items-center px-6 py-4 rounded-lg mb-4" :class="disable ? 'bg-gray-300' : 'bg-platinumHot'">
      <div @click="changeMedia" class="flex items-center cursor-pointer">
        <AccountPhoto :class="disable ? 'filter grayscale' : ''" :image_url="imageUrl" :social="account.provider" :isGroupCover="groupHasCover" :isGroup="account.type === 'group'"/>
        <div class="flex flex-col ml-4">
          <span class="font-bold">@{{ JSON.parse(this.account.metadata)['name'] }}</span>
          <span class=" font-light text-sm">{{account.type}}</span>
        </div>  
      </div>
      <div v-if="account.type=='account'" class="flex items-center text-cosmosFire">   
          <span class=" text-xs mr-2">Connected with</span>
          <FacebookIcon class="h-5"/>
      </div>
         <VueToggles
          v-if="account.type == 'group'"
          height="30"
          width="60"
          checkedText="On"
          uncheckedText="Off"
          checkedBg="#5BD9A4"
          uncheckedBg="lightgrey"
          :value="isActive"
          @click="onToggleClick"
        />
    </div>
  </div>
</template>

<script>
import AccountPhoto from '@/components/scheduler/Common/AccountPhoto';
import FacebookIcon from '@/components/svg/FacebookIcon';
import ConfirmRemovalModal from '@/components/scheduler/Common/ConfirmRemovalModal';

import VueToggles from 'vue-toggles';

export default {
    name:"AccountTypeRow",
    components: {
      AccountPhoto,
      FacebookIcon,
      VueToggles,
      ConfirmRemovalModal,
      VueToggles
  },

  props: {
    account: {
      type:Object,
      require:true
    },
    disable: {
      type:Boolean,
      require:false
    }
  },
  
  data() {
    return {
      removeModalOpen:false,
      isActive: this.account.active === 1,
    }
  },

  methods: {
    changeMedia() {
      this.$emit('changeMedia');
    },

    openConfirmModal(){
      this.removeModalOpen = true;
    },

    closeConfirmModal(){
      this.removeModalOpen = false;
    },

    onToggleClick() {
      this.isActive = !this.isActive;
      this.$inertia.post(this.$route('social-settings.group.update', { groupId: this.account.id }), { active: this.isActive }); 
    }
  },

  computed: {
    imageUrl: function() {
      if(this.account.type === 'group') {
        let metadata = JSON.parse(this.account.metadata);
        if(metadata['cover'] && metadata['cover']['source']) {
          return metadata['cover']['source'];
        } 

        return metadata['icon'];
      }

      return JSON.parse(this.account.metadata)['picture']['data']['url'];
    },

    groupHasCover() {
      if(this.account.type === 'group') {
        let metadata = JSON.parse(this.account.metadata);
        if(metadata['cover'] && metadata['cover']['source']) {
          return true;
        } 

        return false;
      }

      return false;
    }
  }
}
</script>